import BuildingType from '@/roc/building/BuildingType';
import Effects from '@/roc/effects/Effects';

const MongolianFeast = {
  id: '62',
  name: "Mongolian Feast",
  width: 4,
  height: 4,
  type: BuildingType.EVENT,
  era: 'stoneAge',
  icon: 'Mongolian_Feast',
  minLevel: 1,
  maxLevel: 60,
  url: 'https://riseofcultures.wiki.gg/wiki/Buildings/Mongolian_Feast',
  flags: 0,
  counts: null,
  effects: Effects.asEmpty(),
};

export default MongolianFeast;
